"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useReactAdminDoubleClick = function (_a) {
    var onSingleClick = _a.onSingleClick, onDoubleClick = _a.onDoubleClick;
    var clickCount = 0;
    var handleClick = function (event) {
        clickCount++;
        var record = event.record;
        setTimeout(function () {
            if (clickCount === 1) {
                onSingleClick(record);
            }
            else if (clickCount === 2) {
                onDoubleClick(record);
            }
            clickCount = 0;
        }, 200);
    };
    return handleClick;
};
exports.default = useReactAdminDoubleClick;
